import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits, parseUnits } from "viem";
import { useSelector } from "react-redux";
import { ETH, WETHE } from "@config/contractsConfig";

const useDepositEstimate = (amount: string) => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();

  const formattedAmount = !Number.isNaN(amount) ? parseUnits(amount, 18) : "0";

  const { selectedERC20 } = useSelector((state: any) => state.user);

  let args = [formattedAmount];

  // For Avalanche, WETHE is the native token and should be treated like ETH
  // For other chains, only add token address if it's not the native token
  if (
    selectedERC20 !== ETH &&
    selectedERC20 !== WETHE &&
    config.tokens[selectedERC20]?.address
  ) {
    args.push(config.tokens[selectedERC20].address);
  }

  const { data } = useReadContract({
    ...config.interactionPools.lrtDepositPool,
    functionName: "viewSwapRsETHAmountAndFee",
    args: args,
    query: {
      enabled:
        chain &&
        isRestakeSupported &&
        !isEthereumChain &&
        formattedAmount !== "0",
    },
  });

  return data
    ? {
        returns: formatUnits((data as any)[0] as bigint, 18),
        fees: formatUnits((data as any)[1] as bigint, 18),
      }
    : { returns: "0", fees: "0" };
};

export default useDepositEstimate;
